import { Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import Profile from "./pages/Profile";
import SignIn from "./pages/SignIn";
import Main from "./components/layout/Main";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import Users from "./pages/Users";
import Category from "./pages/Category";
import Recipes from "./pages/Recipes";
import RecipeDetails from "./pages/recipeDetails";
import SubCategory from "./pages/SubCategories";
import Devices from "./pages/Devices";
import DeviceLogs from "./pages/deviceLogs";
import DeviceDetails from "./pages/deviceDetails";
import DeviceGraphs from "./pages/deviceTempGraph";
import Firmware from "./pages/Firmware";

function App() {
  return (
    <div className="App">
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<SignIn />} />
        <Route path="/sign-in" element={<SignIn />} />

        {/* Private routes (inside Main layout) */}
        <Route
          path="/*"
          element={
            <Main>
              <Routes>
                <Route path="/dashboard" element={<Home />} />
                <Route path="/recipes" element={<Recipes />} />
                <Route path="/recipeDetails" element={<RecipeDetails />} />
                <Route path="/users" element={<Users />} />
                <Route path="/category" element={<Category />} />
                <Route path="/sub-category" element={<SubCategory />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/devices" element={<Devices />} />
                <Route path="/deviceDetails" element={<DeviceDetails />} />
                <Route path="/deviceLogs" element={<DeviceLogs />} />
                <Route path="/deviceGraph" element={<DeviceGraphs />} />
                <Route path="/firmware" element={<Firmware />} />
                <Route
                  path="*"
                  element={<Navigate to="/dashboard" replace />}
                />
              </Routes>
            </Main>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
